<template>
    <div class="min-h-screen bg-white px-6 py-20 md:px-20 print:px-10 landscape-print">
        <!-- Header -->
        <div class="flex justify-between items-center mb-10">
            <div class="text-xl md:text-3xl font-bold uppercase">Customer Ageing Statement</div>
        </div>

        <!-- Customer and Sales Info -->
        <div class="grid grid-cols-2 gap-6 mb-6">
            <div class="border rounded shadow-sm">
                <div class="bg-gray-100 font-semibold px-4 py-2 border-b">Bill To</div>
                <div class="p-4 text-sm">
                    <div class="font-semibold text-lg">{{ data.name }} ({{ data.kyc.company_name }})</div>
                    <div>{{ data.kyc.business_address }}</div>
                    <div>Tel: {{ data.kyc.phone }}</div>
                </div>
            </div>

            <div class="border rounded shadow-sm">
                <div class="bg-gray-100 font-semibold px-4 py-2 border-b">Sales Info</div>
                <div class="p-4 text-sm">
                    <div class="flex justify-between mb-2">
                        <span class="font-medium">Sales Person:</span>
                        <span><i>Salesperson Name</i></span>
                    </div>
                    <div class="flex justify-between">
                        <span class="font-medium">Date:</span>
                        <span>{{ moment() | readableDate }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Table -->
        <div class="overflow-auto">
            <table class="w-full border border-gray-200 text-sm text-left table-auto">
                <thead class="bg-gray-50 border-b">
                    <tr>
                        <th class="px-3 py-2">Date</th>
                        <th class="px-3 py-2">Invoice No.</th>
                        <th class="px-3 py-2">0 - 30</th>
                        <th class="px-3 py-2">31 - 60</th>
                        <th class="px-3 py-2">61 - 90</th>
                        <th class="px-3 py-2">Over 91</th>
                        <th class="px-3 py-2">Invoice Amount</th>
                        <th class="px-3 py-2">Payment</th>
                        <th class="px-3 py-2">Balance</th>
                        <th class="px-3 py-2">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(bill, index) in bills"
                        :key="bill.id"
                        class="border-b hover:bg-gray-50"
                    >
                        <td class="px-3 py-2">{{ moment(bill.created_at).format('DD/MM/YYYY') }}</td>
                        <td class="px-3 py-2">{{ bill.bill_number }}</td>
                        <td class="px-3 py-2">{{ beforeOneToThirtyDayDue(bill).toFixed(2) }}</td>
                        <td class="px-3 py-2">{{ beforeThirtyOneToSixtyDayDue(bill).toFixed(2) }}</td>
                        <td class="px-3 py-2">{{ beforeSixtyOneToNinetyDayDue(bill).toFixed(2) }}</td>
                        <td class="px-3 py-2">{{ beforeNinetyOneDaysDue(bill).toFixed(2) }}</td>
                        <!-- <td class="px-3 py-2">{{ (bill.transactions_sum_grand_total).toFixed(2) }}</td>
                        <td class="px-3 py-2">{{ (bill.transactions_sum_grand_total - bill.amount_paid).toFixed(2) }}</td> -->
                        <td class="px-3 py-2">{{ (bill.total_amount - 0).toFixed(2) }}</td>
                        <td class="px-3 py-2">{{ (bill.amount_paid - 0).toFixed(2) }}</td>
                        <td class="px-3 py-2">{{ (bill.amount_remaining - 0).toFixed(2) }}</td>

                        <td class="px-3 py-2">
                            <span
                                :class="[
                                    'px-2 py-1 rounded text-xs font-semibold',
                                    bill.amount_paid >= bill.transactions_sum_grand_total
                                        ? 'bg-green-100 text-green-700'
                                        : bill.amount_paid > 0
                                        ? 'bg-yellow-100 text-yellow-700'
                                        : 'bg-red-100 text-red-700',
                                ]"
                            >
                                {{
                                    bill.amount_paid >= bill.transactions_sum_grand_total
                                        ? 'Paid'
                                        : bill.amount_paid > 0
                                        ? 'Partial'
                                        : 'Pending'
                                }}
                            </span>
                        </td>
                    </tr>

                    <tr class="font-semibold bg-gray-100 border-t">
                        <td
                            colspan="2"
                            class="px-3 py-2"
                        >
                            Total
                        </td>
                        <td class="px-3 py-2">{{ totalBefore30.toFixed(2) }}</td>
                        <td class="px-3 py-2">{{ totalBetween31And60.toFixed(2) }}</td>
                        <td class="px-3 py-2">{{ totalBetween61And90.toFixed(2) }}</td>
                        <td class="px-3 py-2">{{ totalOver90.toFixed(2) }}</td>
                        <td class="px-3 py-2">{{ totalAmount.toFixed(2) }}</td>
                        <td class="px-3 py-2">{{ totalPayment.toFixed(2) }}</td>
                        <td class="px-3 py-2">{{ totalDue.toFixed(2) }}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- <div class="flex space-x-6 w-full">
            <!-- Customer    Info 
            <div class="border w-1/2 rounded-sm">
                <div class="font-bold  px-4 py-1 border-b ">
                    Bill To:
                </div>
                <div class="flex flex-col space-y-4 px-4 py-2 font-medium">
                    <div>
                        <span class="uppercase ">{{ data.name }}</span>
                        <span class="mx-1"> {{ `(${data.kyc.company_name})` }} </span>
                    </div>
                    <div>
                        {{ data.kyc.business_address }}
                    </div>
                    <div><span class=" mr-2">Tel:</span> {{ data.kyc.phone }}</div>
                </div>
            </div>
            <!-- Sales Info 
            <div class="w-1/2 ">
                <table class="w-full border border-collapse  table-auto ">
                    <thead class="">
                        <th class=" text-left  px-4 border ">
                            Sales Person
                        </th>
                        <th class=" text-left  px-4 border ">
                            Date
                        </th>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-left  px-4 border ">
                                {{ `
                                < Sales person name here />` }}
                            </td>
                            <td class="text-left  px-4 border ">
                                {{ moment() | readableDate }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="my-8">
            <table class="w-full my-2 border border-collapse  table-auto ">
                <thead class="">
                    <tr>
                        <th class="text-left px-2 border ">
                            Date
                        </th>
                        <th class="text-left px-2 border ">
                            Invoice No.
                        </th>
                        <th class="text-left px-2 border ">
                            0 - 30
                        </th>
                        <th class="text-left px-2 border ">
                            31 - 60
                        </th>
                        <th class="text-left px-2 border ">
                            61 - 90
                        </th>
                        <th class="text-left px-2 border ">
                            Over 91
                        </th>
                        <th class="text-left px-2 border ">
                            Amount
                        </th>
                        <th class="text-left px-2 border ">
                            Balance
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(bill, index) in bills" :key="`bill-${bill.id}`">
                        <td class="px-2 border ">
                            {{ moment(bill.created_at).format('DD/MM/YYYY') }}
                        </td>
                        <td class="px-2 text-left border text-sm">
                            {{ bill.bill_number }}
                        </td>
                        <td class="px-2 text-left border ">
                            <span v-if="beforeOneToThirtyDayDue(bill)" class="text-xs mr-2">
                                {{ config(common.currency) }}
                            </span>
                            {{ beforeOneToThirtyDayDue(bill).toFixed(2) }}
                        </td>
                        <td class="px-2 text-left border ">
                            <span v-if="beforeThirtyOneToSixtyDayDue(bill)" class="text-xs mr-2">
                                {{ config(common.currency) }}
                            </span>
                            {{ beforeThirtyOneToSixtyDayDue(bill).toFixed(2) }}
                        </td>
                        <td class="px-2 text-left border ">
                            <span v-if="beforeSixtyOneToNinetyDayDue(bill)" class="text-xs mr-2">
                                {{ config(common.currency) }}
                            </span>
                            {{ beforeSixtyOneToNinetyDayDue(bill).toFixed(2) }}
                        </td>
                        <td class="px-2 text-left border ">
                            <span v-if="beforeNinetyOneDaysDue(bill)" class="text-xs mr-2">
                                {{ config(common.currency) }}
                            </span>
                            {{ beforeNinetyOneDaysDue(bill).toFixed(2) }}
                        </td>
                        <td class="px-2 text-left border ">
                            <span class="text-xs mr-2"> {{ config(common.currency) }} </span>
                            {{ (bill.transactions_sum_grand_total - bill.amount_paid).toFixed(2) }}
                        </td>
                        <td class="px-2 text-left border ">
                            <span class="text-xs mr-2"> {{ config(common.currency) }} </span>
                            {{ cumulativeAmount(index).toFixed(2) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="px-2 text-left border " />
                        <td class="px-2 text-left border ">
                            Total
                        </td>
                        <td class="px-2 text-left border ">
                            <span class="text-xs mr-2"> {{ config(common.currency) }} </span> {{
                                totalBefore30.toFixed(2) }}
                        </td>
                        <td class="px-2 text-left border ">
                            <span class="text-xs mr-2"> {{ config(common.currency) }} </span> {{
                                totalBetween31And60.toFixed(2) }}
                        </td>
                        <td class="px-2 text-left border ">
                            <span class="text-xs mr-2"> {{ config(common.currency) }} </span> {{
                                totalBetween61And90.toFixed(2) }}
                        </td>
                        <td class="px-2 text-left border ">
                            <span class="text-xs mr-2"> {{ config(common.currency) }} </span> {{ totalOver90.toFixed(2)
                            }}
                        </td>
                        <td class="px-2 text-left border ">
                            <span class="text-xs mr-2"> {{ config(common.currency) }} </span> {{
                                grandTotalAmount.toFixed(2) }}
                        </td>
                        <td class="px-2 text-left border ">
                            <span class="text-xs mr-2"> {{ config(common.currency) }} </span> {{
                                grandTotalAmount.toFixed(2) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div> -->
    </div>
</template>

<script>
    import common from '@/common';

    export default {
        name: 'StatementTemplate',

        props: {
            data: {
                type: Object,
                required: true,
            },
            loggeduser: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                common,
            };
        },

        computed: {
            bills() {
                return this.data.bills || [];
            },
            totalAmount() {
                return this.data.bills.reduce((sum, bill) => sum + parseFloat(bill.transactions_sum_grand_total), 0);
            },
            totalPayment() {
                return this.data.bills.reduce((sum, bill) => sum + parseFloat(bill.amount_paid), 0);
            },
            totalDue() {
                return this.data.bills.reduce((sum, bill) => sum + parseFloat(bill.amount_remaining), 0);
            },

            totalBefore30() {
                return this.data.bills
                    .filter((bill) => this.beforeOneToThirtyDayDue(bill))
                    .map((bill) => parseFloat(bill.transactions_sum_grand_total - bill.amount_paid))
                    .reduce((prev, curr) => prev + curr, 0);
            },

            totalBetween31And60() {
                return this.data.bills
                    .filter((bill) => this.beforeThirtyOneToSixtyDayDue(bill))
                    .map((bill) => parseFloat(bill.transactions_sum_grand_total - bill.amount_paid))
                    .reduce((prev, curr) => prev + curr, 0);
            },

            totalBetween61And90() {
                return this.data.bills
                    .filter((bill) => this.beforeSixtyOneToNinetyDayDue(bill))
                    .map((bill) => parseFloat(bill.transactions_sum_grand_total - bill.amount_paid))
                    .reduce((prev, curr) => prev + curr, 0);
            },

            totalOver90() {
                return this.data.bills
                    .filter((bill) => this.beforeNinetyOneDaysDue(bill))
                    .map((bill) => parseFloat(bill.transactions_sum_grand_total - bill.amount_paid))
                    .reduce((prev, curr) => prev + curr, 0);
            },

            // grandTotalAmount() {
            //     return this.data.bills.reduce((acc, bill) => acc + parseFloat(bill.transactions_sum_grand_total - bill.amount_paid), 0);
            // },
        },

        methods: {
            // cumulativeAmount(index) {
            //     const sumGrandTotalAmount = this.bills
            //         .map((bill, billIndex) => (billIndex <= index ? parseFloat(bill.transactions_sum_grand_total - bill.amount_paid) : 0))
            //         .reduce((prev, curr) => prev + curr, 0);
            //     return sumGrandTotalAmount;
            // },

            // todayDue() {
            //     // transactions_sum_grand_total
            //     return this.user.bills
            //         .filter(bill => this.moment(bill.created_at).isSame(this.moment(), 'day'))
            //         .map(bill => bill.transactions_sum_grand_total)
            //         .reduce((prev, curr) => prev + curr, 0);
            // },

            beforeOneToThirtyDayDue(bill) {
                if (this.moment(bill.created_at).isAfter(this.moment().subtract(30, 'days'), 'day')) {
                    return parseFloat(bill.transactions_sum_grand_total - bill.amount_paid);
                }
                return parseFloat(0);
            },

            beforeThirtyOneToSixtyDayDue(bill) {
                if (
                    this.moment(bill.created_at).isAfter(this.moment().subtract(60, 'days'), 'day') &&
                    this.moment(bill.created_at).isBefore(this.moment().subtract(31, 'days'), 'day')
                ) {
                    return parseFloat(bill.transactions_sum_grand_total);
                }
                return parseFloat(0);
            },

            beforeSixtyOneToNinetyDayDue(bill) {
                if (
                    this.moment(bill.created_at).isAfter(this.moment().subtract(90, 'days'), 'day') &&
                    this.moment(bill.created_at).isBefore(this.moment().subtract(61, 'days'), 'day')
                ) {
                    return parseFloat(bill.transactions_sum_grand_total);
                }

                return parseFloat(0);
            },

            beforeNinetyOneDaysDue(bill) {
                if (this.moment(bill.created_at).isBefore(this.moment().subtract(91, 'days'), 'day')) {
                    return parseFloat(bill.transactions_sum_grand_total);
                }
                return parseFloat(0);
            },

            // exportToPDF() {
            //     window.print(); // placeholder — ideally replace with jsPDF or html2pdf library for real PDF export
            // },
        },
    };
</script>

<!-- <style scoped>
@media print {
  .landscape-print {
    writing-mode: horizontal-tb;
    size: A4 landscape;
  }

  t-button,
  .no-print {
    display: none !important;
  }
}
</style> -->
